import { Component, OnInit, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import { EstateDao } from '@app/dao/estate/estate.dao';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { UserDao } from '@app/dao/user/user.dao';
import { NotificationsService } from '@app/components/notification/NotificationsService';
import * as _ from 'lodash';
import { combineLatest, Subject } from 'rxjs';
import { EaEstateFormComponent } from '../ea-estate-form/ea-estate-form.component';
import { EaFeesFormComponent } from '../ea-fees-form/ea-fees-form.component';
import { EaFeesFormService } from '../ea-fees-form/ea-fees-form.service';
import { EaLmnplmpFormComponent } from '../ea-lmnplmp-form/ea-lmnplmp-form.component';
import { EaScpiFormComponent } from '../ea-scpi-form/ea-scpi-form.component';
import { EaEstatesFormService } from './ea-estates-form.service';

@Component({
    selector: 'ea-estates-form',
    templateUrl: './ea-estates-form.component.html',
    styleUrls: ['./ea-estates-form.component.scss'],
    standalone: false
})
export class EaEstatesFormComponent extends PrFormAbstract implements OnInit {
  users: any[];
  countries: any[] = [];
  personalUseType: any[] = [];
  subscriptionSource: any[] = [];
  doneSubject: Subject<void> = new Subject<void>();
  @ViewChildren(EaFeesFormComponent) feesFormsComponents: EaFeesFormComponent;

  constructor(
    protected formConstructor: PrFormConstructor,
    protected userDao: UserDao,
    private eaEstateFormService: EaEstatesFormService,
  ) {
    super(formConstructor);
  }

  get title() {
    return this.entity && this.entity.label
      ? this.entity.label
      : 'Ajouter un nouveau bien';
  }

  ngOnInit() {
    if (this.entity.typeUrl) this.selectType(this.entity.typeUrl);
  }

  selectType(type) {
    this.userDao.authOnce$().subscribe(user => {
      let entity = {
        userId: user.id,
        accountId: user.accountId,
        typeUrl: type,
        type: 'REAL_ESTATE',
      };

      let formType: any = EaEstateFormComponent;
      if (type == 'unfurnished' || type == 'lmplmnp')
        formType = EaLmnplmpFormComponent;
      else if (type == 'scpi') formType = EaScpiFormComponent;

      this.prFormService.trigger(formType, entity);
    });
  }

  cancelManageAllocationForm() {}
  validManageAllocationForm() {}

  onSubmit() {}

  public generate = () => this.eaEstateFormService.generate(this.entity);
  public extract = () => this.eaEstateFormService.extract(this.form);
  public submit = () => super.submit();
}
